import React, { Component } from 'react';
import Multiselect from 'react-widgets/lib/Multiselect';
import Message from './ValidationMessage';
 

export class MultiselectField extends Component{
    render(){
      let {
        intl,
        translation,
        input={ value: '' },
        required,
        label,
        list = [],
        idField = 'id',
        displayField = 'name',
        meta: { touched, error, warning },
        allowCreate,
        onCreate,
      } = this.props;
  
      if (intl && translation) {
        const labelObj = translation.label;
        if(labelObj && labelObj.message) {
          label = intl.formatMessage(labelObj.message, labelObj.params);
        }
      }
      
      let showError = touched && error ? 'error' : '';
      const requiredClass = required ? 'required' : '';
  
      return (
        <div className={`${requiredClass} field ${showError}`}>
          <label>{label}</label>
          <Multiselect {...input}
            onBlur={() => input.onBlur()}
            value={input.value || []} // requires value to be an array
            data={list}
            valueField={idField}
            textField={displayField}
            allowCreate={allowCreate}
            onCreate={onCreate}
          />
          <Message show={touched} message={error} />
          <Message show={touched} message={warning} />
        </div>
      );
    }
}